import * as React from "react";
import { useGetConfigAppQuery } from "../../../utils/api/config/config.api";
import { createMarkup } from "../../../utils/Utils";
import { TextSkeleton } from "../../admin/Parametres/Steps/CguAdmin";
import FooterPage from "../../auth/FooterPage";
import FrontFooter from "../FrontFooter/FrontFooter";
import FrontHeader from "../FrontHeader/FrontHeader";

const CguPage = () => {
  const { data, isLoading } = useGetConfigAppQuery();
  
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content bg-white py-5">
        <div className="container-easy-market">
          <div className="container">
            <div className="container-banner-policy">
              <h2 className="title-banner-policy">Politique générale de vente</h2>
            </div>
            <div className="container-text-policy pb-5">
              {!!isLoading && <TextSkeleton />}
              {!isLoading && (
                data?.cgu ? (
                  <div
                    className="text-policy"
                    dangerouslySetInnerHTML={createMarkup(data?.cgu)}
                  />
                ) : (
                  <div className="custom-politique-page-content pt-5">
                    <div className="content-all-politique pt-4 pb-3">
                      <div className="content-politique-item">
                        <h3 className="custom-sm-title pb-4">
                          1. Commandes et Paiements
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>1.1. Passer une Commande :</strong> Lorsque vous passez une commande sur notre site, vous acceptez d'acheter les produits ou services sélectionnés aux prix et conditions indiqués.
                          </div>
                          <div className="custom-sm-value pt-2">
                            <strong>1.2. Paiements :</strong> Les paiements sont traités de manière sécurisée via des méthodes de paiement en ligne sécurisées. Les informations de paiement sont cryptées et protégées.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          2. Livraison et Frais de Port
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>2.1. Livraison :</strong> Nous nous engageons à expédier vos commandes dans les délais <strong>3 jours</strong>.
                          </div>
                          <div className="custom-sm-value pt-2">
                            <strong>2.2. Frais de livraison :</strong> Les frais de livraison sont à la charge du client.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          3. Politique de Retour et de Remboursement
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>3.1. Retours :</strong> Si vous n'êtes pas entièrement satisfait de votre achat, vous disposez de <strong>3 jours</strong> après réception de l'article pour le retourner.
                          </div>
                          <div className="custom-sm-value pt-2">
                            <strong>3.2. Remboursements :</strong> Les remboursements seront effectués dans un délai de <strong>7 jours</strong> après réception de l'article retourné et vérification de son état.
                          </div>
                          <div className="custom-sm-value pt-2">
                            Les articles doivent être non utilisés, dans leur emballage d'origine.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          4. Garantie
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>4.1.</strong> Les produits ont une garantie de 6 mois.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          5. Responsabilité
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>5.1. Limitation de Responsabilité :</strong> Nous déclinons toute responsabilité pour tout dommage direct, indirect, spécial, consécutif ou punitif résultant de l'utilisation de nos produits ou services.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          6. Modifications de la Politique
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>6.1. Modifications :</strong> Nous nous réservons le droit de modifier cette Politique à tout moment. Les modifications seront effectives dès leur publication sur notre site.
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          7. Contact
                        </h3>
                        <div className="custom-sm-value">
                          <div className="custom-sm-value">
                            <strong>7.1. Contact :</strong> Pour toute question concernant notre Politique Générale de Ventes, veuillez nous contacter via les coordonnées fournies sur notre site.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
          <FooterPage />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default CguPage;